export const COOKIE = {
  GID: '_ifgid',
  INSIGN: '_ifinsign',
  INSIGN_FRONT: '_ifinsign_front',
  LOCALE: '_iflocale',
  LANGUAGE: '_iflanguage',
  PLATFORM: '_ifplatform',
  PLATFORM_SELECTOR: '_ifplatform_selector',
  WEB_TOKEN: '_ifwt',
  WEB_TOKEN_SSO: '_ifwt_sso',
  DISABLE_WEB_LAUNCH: '_if_disable_web_launch',
}

export const PATH = {
  SSO_TICKET: 'insign',
  SIMPLE_SIGNUP: 'simple-signup',
}

export const PAGES = {
  IAC_CONSENT_OAUTH: 'pages/consent/information-provision',
  IAC_CONSENT_TERMS: 'pages/consent/terms',
  IAL_TWITCH_PLATFORM_SELECTOR: 'pages/twitch-linking/platform-selector',
  IAL_TWITCH_ACCOUNT_INFO: 'pages/twitch-linking/account-info',
  IAL_CHZZK_PLATFORM_SELECTOR: 'pages/chzzk-linking/platform-selector',
  IAL_CHZZK_ACCOUNT_INFO: 'pages/chzzk-linking/account-info',
  IAL_DISCOTECH_LINKING: 'pages/discotech-linking',
  IAL_PLATFORM_SIGNIN: 'pages/account/signin',
  IAL_AUTH_SELECTOR: 'pages/account/auth-selector',
  IAL_AUTH_SELECTOR_EXTERNAL: 'pages/account/auth-selector/external',
  IAL_AUTH_SELECTOR_MOBILE: 'pages/account/auth-selector/mobile',
  IAL_LOGIN_SELECTOR: 'pages/login-selector',
  IAL_LOGIN_SELECTOR_HEADLESS: 'pages/login-selector/code',
  IIV: 'pages/verification/identity',
  SA_SHOW_ACCOUNT_MENU: 'pages/setting/account/link',
  SA_SHOW_ACCOUNT_MENU_RESULT: 'pages/setting/account/link/result',
}

export const PAGES_SUPPORTED_LANGUAGE = [
  'ko',
  'en',
  'ja',
  'es',
  'pt-BR',
  'de',
  'nl',
  'fr',
  'it',
  'pl',
  'tr',
  'ru',
  'th',
  'zh-TW',
]
